import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/lang";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "beintec-cookie-consent";

const track = (path, lang) => {
  if (localStorage.getItem(KEY) !== "accepted") return;
  fetch(`${API}/analytics/pageview`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, lang }),
    keepalive: true,
  }).catch(() => {});
};

const PageTracker = () => {
  const location = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    track(location.pathname, lang);
  }, [location.pathname, lang]);

  useEffect(() => {
    const onConsent = () => track(window.location.pathname, lang);
    window.addEventListener("beintec-consent", onConsent);
    return () => window.removeEventListener("beintec-consent", onConsent);
  }, [lang]);

  return null;
};

export default PageTracker;
